import { vuexEventPathGenerator } from '@/utils';
const getterType = {
    getterIsOpenModalAllocate: 'getterIsOpenModalAllocate',
};
export const allocationControllerGetterType = vuexEventPathGenerator(getterType, 'allocationController');
const getter = {
    [getterType.getterIsOpenModalAllocate](state) {
        return Object.keys(state.selectedOrderItemsObj)?.length || !!state.selectedWorker;
    },
};
export default getter;
